// extracted by mini-css-extract-plugin
export default {"commodityWrapper":"CommoditiesAddOrganism_commodityWrapper__urg6B"};